export default __webpack_public_path__ + "static/media/calidadpresentaciones.dae702f6.png";